import React, { useState, useEffect } from "react";
import "./login.css";
import "./login.scss";

// import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import logo from "../../images/PPKM_Head.png";
import { useNavigate } from "react-router-dom";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { IconButton } from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";
import getEventController from "../Member/Controller/getEvent_controller";

//graphics
import GoogleStoreQr from '../../assets/images/ppkm_google_store.png';
import AppStoreQr from '../../assets/images/ppkm_apple_store.png';
import AppIcon from '../../assets/images/appIcon.png';

const Login = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [memberId, setMemberId] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    window.location.href = "https://www.ppkm.org.my/ppkm-web/";
  }, []);

  const handleLogin = async (e) => {

    e.preventDefault();
    setError(null); // Reset error

    console.log(email);

    // Call the authentication function
    const data = await getEventController.CheckMemberExist(email);

    console.log(data);

    if (data === true) {
      // If successful, navigate to the next page, e.g., OTP page or dashboard
      // navigate("/otp", { state: { email, sent_otp: data } });
      navigate("/membership_selection", { state: { email } });

      // console.log(data);
    } else {
      setError("Email is not active. Please try again.");
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-wrapper">
          <div className="login-title">
            <img className="web-login-logo" src={logo} alt="Logo" />
          </div>
          <p className="title_para">PPKM </p>
          <p className="title_para2">Malaysia Shopping Malls Association</p>

          <form onSubmit={handleLogin}>
            {/* email address */}
            <label className="web-login-label">
              Please provide the registered email address to log in.
            </label>
            <div className="login-input-row">
              <EmailIcon className="login-form-logo" />
              <input
                type="email"
                placeholder="Email Address"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="login-input-row2 button">
              <input type="submit" value="Login" />
            </div>
            {error && <p className="error-message">{error}</p>}
            {/* retreive email */}
            <div>
              <div className="forgot-password">
                <label>What is my email address?</label>
              </div>
              <div className="pass ">
                <a onClick={() => navigate("/retrieve_email")}>
                  Retrieve Email
                </a>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div className='login-popup'>
        <div className='login-popup-menu'>
          <span className='login-popup-lbl'>
            The page is currently undergoing maintenance and update.<br/>
            For the meantime, scan the qr-codes below and download the Mobile App<br/>to access all membership features.
          </span>
          <div className='login-popup-row'>
            <img className="login-popup-img" src={GoogleStoreQr}/>
            <img className="login-popup-img ex" src={AppIcon}/>
            <img className="login-popup-img" src={AppStoreQr}/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
